import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PriceProviderService {
  private readonly storagePrefix = 'priceProvider.';

  private _isFwc: boolean = false;
  get isFwc(): boolean {
    return this._isFwc;
  }
  set isFwc(value: boolean) {
    this._isFwc = value;
    this.saveKey('isFwc', value);
  }


  private _aProPrice: number = 7_000_000;
  get aProPrice(): number {
    return this._aProPrice;
  }
  set aProPrice(value: number) {
    this._aProPrice = value;
    this.saveKey('aProPrice', value);
  }

  private _sProPrice: number = 14_000_000;
  get sProPrice(): number {
    return this._sProPrice;
  }
  set sProPrice(value: number) {
    this._sProPrice = value;
    this.saveKey('sProPrice', value);
  }

  private _sProLowPrice: number = 1_000;
  get sProLowPrice(): number {
    return this._sProLowPrice;
  }
  set sProLowPrice(value: number) {
    this._sProLowPrice = value;
    this.saveKey('sProLowPrice', value);
  }

  private _gProPrice: number = 15_000_000;
  get gProPrice(): number {
    return this._gProPrice;
  }
  set gProPrice(value: number) {
    this._gProPrice = value;
    this.saveKey('gProPrice', value);
  }

  private _xProPrice: number = 23_400_000;
  get xProPrice(): number {
    return this._xProPrice;
  }
  set xProPrice(value: number) {
    this._xProPrice = value;
    this.saveKey('xProPrice', value);
  }

  private _pd4Price: number = 0;
  get pd4Price(): number {
    return this._pd4Price;
  }
  set pd4Price(value: number) {
    this._pd4Price = value;
    this.saveKey('pd4Price', value);
  }

  private _pd6Price: number = 0;
  get pd6Price(): number {
    return this._pd6Price;
  }
  set pd6Price(value: number) {
    this._pd6Price = value;
    this.saveKey('pd6Price', value);
  }

  private _pd8Price: number = 0;
  get pd8Price(): number {
    return this._pd8Price;
  }
  set pd8Price(value: number) {
    this._pd8Price = value;
    this.saveKey('pd8Price', value);
  }

  private _sunstonePrice: number = 80_000_000;
  get sunstonePrice(): number {
    return this._sunstonePrice;
  }
  set sunstonePrice(value: number) {
    this._sunstonePrice = value;
    this.saveKey('sunstonePrice', value);
  }

  private _eronPrice: number = 7_000;
  get eronPrice(): number {
    return this._eronPrice;
  }
  set eronPrice(value: number) {
    this._eronPrice = value;
    this.saveKey('eronPrice', value);
  }

  private _mineralPrice: number = 7_000;
  get mineralPrice(): number {
    return this._mineralPrice;
  }
  set mineralPrice(value: number) {
    this._mineralPrice = value;
    this.saveKey('mineralPrice', value);
  }

  constructor() {
    // Load saved values from localStorage (if any)
    const isFwc = this.loadBoolean('isFwc');
    if (isFwc !== null) this._isFwc = isFwc;

    const aPro = this.loadNumber('aProPrice');
    if (aPro !== null) this._aProPrice = aPro;

    const sPro = this.loadNumber('sProPrice');
    if (sPro !== null) this._sProPrice = sPro;

    const sProLow = this.loadNumber('sProLowPrice');
    if (sProLow !== null) this._sProLowPrice = sProLow;

    const gPro = this.loadNumber('gProPrice');
    if (gPro !== null) this._gProPrice = gPro;

    const xPro = this.loadNumber('xProPrice');
    if (xPro !== null) this._xProPrice = xPro;

    const pd4 = this.loadNumber('pd4Price');
    if (pd4 !== null) this._pd4Price = pd4;

    const pd6 = this.loadNumber('pd6Price');
    if (pd6 !== null) this._pd6Price = pd6;

    const pd8 = this.loadNumber('pd8Price');
    if (pd8 !== null) this._pd8Price = pd8;

    const sun = this.loadNumber('sunstonePrice');
    if (sun !== null) this._sunstonePrice = sun;

    const eron = this.loadNumber('eronPrice');
    if (eron !== null) this._eronPrice = eron;

    const min = this.loadNumber('mineralPrice');
    if (min !== null) this._mineralPrice = min;
  }

  private saveKey(key: string, value: any): void {
    try {
      localStorage.setItem(this.storagePrefix + key, JSON.stringify(value));
    } catch {
      // ignore storage errors (e.g., storage full, private mode)
    }
  }

  private loadNumber(key: string): number | null {
    try {
      const v = localStorage.getItem(this.storagePrefix + key);
      if (v === null) return null;
      const parsed = JSON.parse(v);
      return typeof parsed === 'number' ? parsed : Number(parsed);
    } catch {
      return null;
    }
  }

  private loadBoolean(key: string): boolean | null {
    try {
      const v = localStorage.getItem(this.storagePrefix + key);
      if (v === null) return null;
      const parsed = JSON.parse(v);
      return typeof parsed === 'boolean' ? parsed : parsed === 'true';
    } catch {
      return null;
    }
  }
}
